/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/axiosInstance.js";
import type { GetSession1QueryResponse, GetSession1PathParams, GetSession1400, GetSession1401, GetSession1403, GetSession1404, GetSession1409, GetSession1500 } from "../../types/GetSession1.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/axiosInstance.js";

function getGetSession1Url(sessionId: GetSession1PathParams["sessionId"]) {
  const res = { method: 'GET', url: `/api/research-chat/${sessionId}` as const }
  return res
}

/**
 * @description Retrieves the complete chat session including all messages and their citations.
 * @summary Get session with all messages
 * {@link /api/research-chat/:sessionId}
 */
export async function getSession1(sessionId: GetSession1PathParams["sessionId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetSession1QueryResponse, ResponseErrorConfig<GetSession1400 | GetSession1401 | GetSession1403 | GetSession1404 | GetSession1409 | GetSession1500>, unknown>({ method : "GET", url : getGetSession1Url(sessionId).url.toString(), ... requestConfig })
  return res.data
}